import React from "react";
import { motion } from "framer-motion";
import { Wallet, Wrench, MonitorSmartphone, Headset, HardHat, CalendarClock } from "lucide-react";
import { FEATURES } from "../../data/flyzone";

const ICONS = {
  wallet: Wallet,
  wrench: Wrench,
  monitor: MonitorSmartphone,
  headset: Headset,
  helmet: HardHat,
  calendar: CalendarClock,
};

export const WhyChooseUs = () => {
  return (
    <section id="why" className="relative py-20 sm:py-28 bg-[#0D0D0D] border-y border-white/5">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl mb-14">
          <span className="text-primary font-semibold text-sm uppercase tracking-widest">Why Choose Us</span>
          <h2 className="mt-3 text-3xl sm:text-5xl font-display font-bold tracking-tight">
            Built for riders who expect more
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {FEATURES.map((f, i) => {
            const Icon = ICONS[f.icon];
            return (
              <motion.div
                key={f.title}
                data-testid={`feature-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.45, delay: (i % 3) * 0.08 }}
                className="group relative rounded-2xl p-7 bg-[#141414] border border-white/10 hover:border-primary/40 hover:-translate-y-1 transition-[transform,border-color] duration-300"
              >
                <div className="grid place-items-center w-12 h-12 rounded-xl bg-primary/15 text-primary mb-5 group-hover:bg-primary group-hover:text-black transition-colors duration-300">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="text-lg font-display font-bold">{f.title}</h3>
                <p className="mt-2 text-sm text-white/60 leading-relaxed">{f.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
